/**
 * Minimal interactions: mobile nav, product variants, gallery, accordions, AJAX add-to-cart.
 */
(function () {
    function formatMoney(cents, currencyCode) {
      try {
        return (cents / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: currencyCode || 'USD',
        });
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }
  
    function initMobileMenu() {
      const openBtn = document.querySelector('[data-mobile-menu-open]');
      const drawer = document.querySelector('[data-mobile-menu]');
      if (!openBtn || !drawer) return;
  
      const closeEls = drawer.querySelectorAll('[data-mobile-menu-close]');
  
      function open() {
        drawer.removeAttribute('hidden');
        openBtn.setAttribute('aria-expanded', 'true');
      }
  
      function close() {
        drawer.setAttribute('hidden', '');
        openBtn.setAttribute('aria-expanded', 'false');
      }
  
      openBtn.addEventListener('click', () => {
        if (drawer.hasAttribute('hidden')) open();
        else close();
      });
  
      closeEls.forEach((el) => el.addEventListener('click', close));
    }
  
    function initLocalizationForms() {
      document.querySelectorAll('[data-localization-option]').forEach((option) => {
        const form = option.closest('form');
        if (!form) return;
  
        const localeInput = form.querySelector('[data-localization-locale]');
        const countryInput = form.querySelector('[data-localization-country]');
  
        option.addEventListener('click', () => {
          if (localeInput && option.dataset.localeCode) localeInput.value = option.dataset.localeCode;
          if (countryInput && option.dataset.countryCode) countryInput.value = option.dataset.countryCode;
          form.submit();
        });
      });
  
      document.addEventListener('click', (event) => {
        document.querySelectorAll('[data-localization-details][open]').forEach((details) => {
          if (!details.contains(event.target)) details.removeAttribute('open');
        });
      });
    }
  
    function initHistoryBack() {
      document.querySelectorAll('[data-history-back]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (window.history.length > 1) window.history.back();
          else window.location.href = '/collections/all';
        });
      });
    }
  
    function initAccordions() {
      document.querySelectorAll('[data-accordion]').forEach((root) => {
        const btn = root.querySelector('[data-accordion-btn]');
        const panel = root.querySelector('[data-accordion-panel]');
        if (!btn || !panel) return;
  
        btn.addEventListener('click', () => {
          const open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) {
            panel.setAttribute('hidden', '');
            root.classList.remove('is-open');
          } else {
            panel.removeAttribute('hidden');
            root.classList.add('is-open');
          }
        });
      });
    }
  
    function initReadMore() {
      document.querySelectorAll('[data-read-more-wrap]').forEach((wrap) => {
        const content = wrap.querySelector('[data-read-more-content]');
        const btn = wrap.querySelector('[data-read-more-toggle]');
        if (!content || !btn) return;
  
        const updateOverflow = () => {
          wrap.classList.add('is-clamped');
          const hasOverflow = content.scrollHeight > content.clientHeight + 2;
          wrap.classList.toggle('has-overflow', hasOverflow);
        };
  
        btn.addEventListener('click', () => {
          const clamped = wrap.classList.toggle('is-clamped');
          btn.textContent = clamped ? btn.dataset.readMoreText || '+ Read more' : btn.dataset.readLessText || '- Read less';
        });
  
        updateOverflow();
        window.addEventListener('resize', updateOverflow, { passive: true });
      });
    }
  
    function initQuantity(root) {
      root.querySelectorAll('[data-quantity-wrap]').forEach((wrap) => {
        const input = wrap.querySelector('[data-quantity-input]');
        const dec = wrap.querySelector('[data-qty-decrease]');
        const inc = wrap.querySelector('[data-qty-increase]');
        if (!input || !dec || !inc) return;
  
        const min = Number(input.getAttribute('min')) || 1;
        dec.addEventListener('click', () => {
          const v = Math.max(min, Number(input.value) - 1);
          input.value = String(v);
        });
        inc.addEventListener('click', () => {
          const maxAttr = input.getAttribute('max');
          const max = maxAttr ? Number(maxAttr) : Infinity;
          const v = Math.min(max, Number(input.value) + 1);
          input.value = String(v);
        });
      });
    }
  
    function getSelectedOptions(form) {
      return Array.from(form.querySelectorAll('[data-option-select]'))
        .sort((a, b) => Number(a.dataset.optionSelect) - Number(b.dataset.optionSelect))
        .map((sel) => sel.value);
    }
  
    function findVariant(product, options) {
      return product.variants.find((v) => {
        const vals = [v.option1, v.option2, v.option3];
        for (let i = 0; i < options.length; i++) {
          const a = vals[i] == null ? '' : String(vals[i]);
          const b = options[i] == null ? '' : String(options[i]);
          if (a !== b) return false;
        }
        return true;
      });
    }
  
    function isFlPdpMobile() {
      return window.matchMedia('(max-width: 899px)').matches;
    }
  
    function getVariantMediaId(variant, product) {
      if (!variant) return null;
      if (variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
      if (variant.featured_image && variant.featured_image.id) return variant.featured_image.id;
      if (!product || !product.media) return null;
      const match = product.media.find((m) => {
        if (!m.variant_ids || !m.variant_ids.length) return false;
        return m.variant_ids.includes(variant.id);
      });
      return match ? match.id : null;
    }

    function scrollActiveThumbIntoView(root) {
      const thumbsWrap = root.querySelector('[data-gallery-thumbs]');
      const activeThumb = root.querySelector('.product-gallery__thumb.is-active');
      if (!thumbsWrap || !activeThumb) return;
      activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    function updateThumbNavButtons(root) {
      const thumbsWrap = root.querySelector('[data-gallery-thumbs]');
      const upBtn = root.querySelector('[data-thumb-scroll="up"]');
      const downBtn = root.querySelector('[data-thumb-scroll="down"]');
      if (!thumbsWrap || !upBtn || !downBtn) return;

      const vertical = window.matchMedia('(min-width: 750px)').matches;
      const overflow = vertical
        ? thumbsWrap.scrollHeight > thumbsWrap.clientHeight + 2
        : thumbsWrap.scrollWidth > thumbsWrap.clientWidth + 2;

      upBtn.hidden = !overflow;
      downBtn.hidden = !overflow;
    }

    function setGalleryActive(root, mediaId) {
      if (!mediaId) return;
      const slides = root.querySelectorAll('.product-gallery__slide');
      const thumbs = root.querySelectorAll('.product-gallery__thumb');
      const track = root.querySelector('[data-fl-pdp-track]');
      const id = String(mediaId);
      slides.forEach((s) => {
        s.classList.toggle('is-active', String(s.dataset.mediaId) === id);
      });
      thumbs.forEach((t) => {
        const active = String(t.dataset.mediaId) === id;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      scrollActiveThumbIntoView(root);
      if (track && isFlPdpMobile()) {
        const idx = Array.from(slides).findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
        if (idx >= 0) track.scrollTo({ left: track.clientWidth * idx, behavior: 'auto' });
      }
    }

    function stepGallery(root, delta) {
      const slides = Array.from(root.querySelectorAll('.product-gallery__slide'));
      if (slides.length < 2) return;
      const current = slides.findIndex((s) => s.classList.contains('is-active'));
      const next = (current + delta + slides.length) % slides.length;
      const mediaId = slides[next].dataset.mediaId;
      if (mediaId) setGalleryActive(root, mediaId);
    }
  
    function initProductGallery(root) {
      const track = root.querySelector('[data-fl-pdp-track]');
      const thumbs = root.querySelectorAll('.product-gallery__thumb[data-thumb-index]');
      const slides = root.querySelectorAll('.product-gallery__slide');
      if (!thumbs.length || !slides.length) return;
  
      function desktopActivate(idx) {
        slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
        thumbs.forEach((t, i) => {
          t.classList.toggle('is-active', i === idx);
          t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
      }
  
      thumbs.forEach((btn) => {
        btn.addEventListener('click', () => {
          const idx = Number(btn.dataset.thumbIndex);
          if (track && isFlPdpMobile()) {
            track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
          } else {
            desktopActivate(idx);
          }
        });
      });
  
      if (track && slides.length > 1) {
        const syncFromScroll = () => {
          if (!isFlPdpMobile()) return;
          const w = track.clientWidth || 1;
          const idx = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
          desktopActivate(idx);
        };
        let raf;
        track.addEventListener(
          'scroll',
          () => {
            if (!isFlPdpMobile()) return;
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(syncFromScroll);
          },
          { passive: true }
        );
      }
    }
  
    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = String(count);
        el.classList.toggle('hidden', count === 0);
      });
      document.querySelectorAll('[data-cart-notification-count]').forEach((el) => {
        el.textContent = String(count);
      });
    }

    function hideCartNotification() {
      const el = document.querySelector('[data-cart-notification]');
      if (el) el.setAttribute('hidden', '');
    }

    function showCartNotification(item, cartCount) {
      const root = document.querySelector('[data-cart-notification]');
      if (!root) return;

      const productWrap = root.querySelector('[data-cart-notification-product]');
      const imageEl = root.querySelector('[data-cart-notification-image]');
      const titleEl = root.querySelector('[data-cart-notification-title]');
      const variantEl = root.querySelector('[data-cart-notification-variant]');

      if (item && productWrap) {
        productWrap.removeAttribute('hidden');
        if (titleEl) titleEl.textContent = item.product_title || item.title || '';
        if (variantEl) {
          const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          variantEl.textContent = variantTitle ? `Type: ${variantTitle}` : '';
          variantEl.hidden = !variantTitle;
        }
        if (imageEl) {
          const imgUrl = item.image || (item.featured_image && item.featured_image.url) || '';
          imageEl.innerHTML = imgUrl
            ? `<img src="${imgUrl}" alt="" width="72" height="72" loading="lazy">`
            : '';
        }
      }

      updateCartCount(cartCount);
      root.removeAttribute('hidden');
    }

    async function refreshCartCount() {
      try {
        const res = await fetch('/cart.js');
        if (!res.ok) return null;
        const cart = await res.json();
        updateCartCount(cart.item_count);
        return cart;
      } catch (e) {
        return null;
      }
    }

    async function addToCartAjax(formData) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const err = new Error(data.description || data.message || 'Could not add to cart');
        err.data = data;
        throw err;
      }
      const cart = await refreshCartCount();
      showCartNotification(data, cart ? cart.item_count : 1);
      return data;
    }
  
    function initProductPage() {
      const root = document.querySelector('[data-section-type="product"]');
      if (!root) return;
  
      const jsonEl = root.querySelector('[data-product-json]');
      const form = root.querySelector('[data-product-form]');
      if (!jsonEl || !form) return;
  
      let product;
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }
  
      const currency = root.dataset.currencyCode || 'USD';
      const variantInput = form.querySelector('[data-variant-id-input]');
      const priceEl = root.querySelector('[data-price]');
      const compareEl = root.querySelector('[data-compare-price]');
      const addBtn = form.querySelector('[data-add-to-cart]');
      const errBox = form.querySelector('[data-product-form-error]');
  
      initProductGallery(root);
  
      function applyVariant(variant) {
        if (!variant) return;
  
        if (variantInput) variantInput.value = String(variant.id);
  
        if (priceEl) priceEl.textContent = formatMoney(variant.price, currency);
  
        if (compareEl) {
          const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
          compareEl.classList.toggle('hidden', !hasCompare);
          if (hasCompare) compareEl.textContent = formatMoney(variant.compare_at_price, currency);
        }
  
        if (addBtn) {
          addBtn.disabled = !variant.available;
          const la = addBtn.dataset.labelAvailable;
          const ls = addBtn.dataset.labelSold;
          addBtn.textContent = variant.available ? la || 'Add to cart' : ls || 'Sold out';
        }
  
        const fid = variant.featured_image && variant.featured_image.id;
        if (fid) setGalleryActive(root, fid);
  
        [1, 2, 3].forEach((pos) => {
          const lab = root.querySelector(`[data-option-label-${pos}]`);
          if (!lab) return;
          const key = `option${pos}`;
          if (variant[key] != null) lab.textContent = variant[key];
        });
  
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
      }
  
      form.querySelectorAll('[data-option-select]').forEach((sel) => {
        sel.addEventListener('change', () => {
          const opts = getSelectedOptions(form);
          const variant = findVariant(product, opts);
          if (variant) applyVariant(variant);
        });
      });
  
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (errBox) {
          errBox.classList.add('hidden');
          errBox.textContent = '';
        }
  
        const fd = new FormData(form);
        try {
          await addToCartAjax(fd);
        } catch (err) {
          if (errBox) {
            errBox.textContent = err.message || 'Network error';
            errBox.classList.remove('hidden');
          }
        }
      });
    }
  
    function initProductRecommendations() {
      document.querySelectorAll('[data-product-recommendations]').forEach(async (root) => {
        const url = root.dataset.url;
        if (!url || root.dataset.loaded === 'true') return;
  
        root.dataset.loaded = 'true';
        try {
          const res = await fetch(url);
          if (!res.ok) return;
          const text = await res.text();
          const html = new DOMParser().parseFromString(text, 'text/html');
          const next = html.querySelector('[data-product-recommendations]');
          if (!next) return;
          const grid = next.querySelector('[data-product-recommendations-grid]');
          const currentGrid = root.querySelector('[data-product-recommendations-grid]');
          if (grid && currentGrid && grid.children.length) {
            currentGrid.innerHTML = grid.innerHTML;
            root.hidden = false;
          }
        } catch (e) {
          /* Recommendation fetch is optional. */
        }
      });
    }
  
    function initRosiaGallery(root) {
      const gallery = root.querySelector('[data-product-gallery]');
      if (!gallery) return;

      const thumbs = root.querySelectorAll('.product-gallery__thumb[data-media-id]');
      const thumbsWrap = root.querySelector('[data-gallery-thumbs]');
      const prevBtn = root.querySelector('[data-gallery-prev]');
      const nextBtn = root.querySelector('[data-gallery-next]');
      const thumbUp = root.querySelector('[data-thumb-scroll="up"]');
      const thumbDown = root.querySelector('[data-thumb-scroll="down"]');

      thumbs.forEach((btn) => {
        btn.addEventListener('click', () => {
          const mediaId = btn.dataset.mediaId;
          if (mediaId) setGalleryActive(root, mediaId);
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', () => stepGallery(root, -1));
      if (nextBtn) nextBtn.addEventListener('click', () => stepGallery(root, 1));

      const scrollThumbs = (direction) => {
        if (!thumbsWrap) return;
        const vertical = window.matchMedia('(min-width: 750px)').matches;
        const amount = vertical ? thumbsWrap.clientHeight * 0.75 : thumbsWrap.clientWidth * 0.75;
        thumbsWrap.scrollBy({
          top: vertical ? amount * direction : 0,
          left: vertical ? 0 : amount * direction,
          behavior: 'smooth',
        });
      };

      if (thumbUp) thumbUp.addEventListener('click', () => scrollThumbs(-1));
      if (thumbDown) thumbDown.addEventListener('click', () => scrollThumbs(1));

      if (thumbsWrap) {
        thumbsWrap.addEventListener('scroll', () => updateThumbNavButtons(root), { passive: true });
        window.addEventListener('resize', () => updateThumbNavButtons(root), { passive: true });
        updateThumbNavButtons(root);
      }

      const stage = root.querySelector('.product-gallery__stage');
      if (stage && thumbs.length > 1) {
        let touchStartX = 0;
        stage.addEventListener(
          'touchstart',
          (e) => {
            touchStartX = e.changedTouches[0].screenX;
          },
          { passive: true }
        );
        stage.addEventListener(
          'touchend',
          (e) => {
            const diff = e.changedTouches[0].screenX - touchStartX;
            if (Math.abs(diff) < 40) return;
            stepGallery(root, diff > 0 ? -1 : 1);
          },
          { passive: true }
        );
      }
    }

    function initRosiaPdp() {
      document.querySelectorAll('[data-fl-pdp="rosia-minimal"]').forEach((root) => {
        const price = root.querySelector('[data-rosia-price]');
        const compare = root.querySelector('[data-rosia-compare-price]');
        const add = root.querySelector('[data-rosia-add-button]');  
        const form = root.querySelector('[data-rosia-product-form]');
        const errBox = root.querySelector('[data-rosia-form-error]');
        const jsonEl = root.querySelector('[data-rosia-product-json]');
        let productData = null;

        if (jsonEl) {
          try {
            productData = JSON.parse(jsonEl.textContent);
          } catch (e) {
            productData = null;
          }
        }

        initRosiaGallery(root);

        const currency = root.dataset.currencyCode || 'USD';
        const variantIdInput = root.querySelector('[data-rosia-variant-id]');

        function getRosiaSelectedOptions() {
          const groups = Array.from(root.querySelectorAll('[data-rosia-option]'));
          if (!groups.length) return null;
          const values = [];
          groups.forEach((group) => {
            const idx = parseInt(group.dataset.rosiaOption, 10);
            const checked = group.querySelector('input:checked');
            values[idx] = checked ? checked.value : null;
          });
          return values;
        }

        function findRosiaVariant(options) {
          if (!productData || !options) return null;
          return productData.variants.find((variant) =>
            variant.options.every((opt, index) => opt === options[index])
          );
        }

        function applyRosiaVariantData(variant) {
          if (!variant) return;

          if (variantIdInput) variantIdInput.value = String(variant.id);

          if (price) {
            price.textContent = formatMoney(variant.price, currency);
            const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
            price.classList.toggle('price-sale', onSale);
            price.classList.toggle('price-current', !onSale);
          }

          if (compare) {
            const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
            compare.classList.toggle('hidden', !hasCompare);
            if (hasCompare) compare.textContent = formatMoney(variant.compare_at_price, currency);
          }

          if (add) {
            add.disabled = !variant.available;
            add.textContent = variant.available ? 'Add to cart' : 'Sold out';
          }

          const mediaId = getVariantMediaId(variant, productData);
          if (mediaId) setGalleryActive(root, mediaId);

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        function syncRosiaVariantFromOptions() {
          const variant = findRosiaVariant(getRosiaSelectedOptions());
          if (variant) applyRosiaVariantData(variant);
        }

        root.querySelectorAll('[data-rosia-option-value]').forEach((input) => {
          input.addEventListener('change', syncRosiaVariantFromOptions);
        });

        if (variantIdInput) {
          syncRosiaVariantFromOptions();
        }

        if (form) {
          form.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (errBox) {
              errBox.classList.add('hidden');
              errBox.textContent = '';
            }
            if (add) add.disabled = true;
            try {
              await addToCartAjax(new FormData(form));
            } catch (err) {
              if (errBox) {
                errBox.textContent = err.message || 'Could not add to cart';
                errBox.classList.remove('hidden');
              }
            } finally {
              if (add && !add.hasAttribute('data-sold-out')) add.disabled = false;
            }
          });
        }

        root.querySelectorAll('[data-rosia-share]').forEach((btn) => {
          btn.addEventListener('click', async () => {
            const shareData = { title: document.title, url: window.location.href };
            if (navigator.share) {
              try {
                await navigator.share(shareData);
                return;
              } catch (e) {
                /* fall through to clipboard */
              }
            }
            try {
              await navigator.clipboard.writeText(window.location.href);
              btn.textContent = 'Link copied';
              window.setTimeout(() => {
                btn.textContent = 'Share';
              }, 1600);
            } catch (e) {
              window.prompt('Copy this link', window.location.href);
            }
          });
        });
      });
    }

    function initCartNotification() {
      const root = document.querySelector('[data-cart-notification]');
      if (!root) return;

      root.querySelectorAll('[data-cart-notification-close]').forEach((btn) => {
        btn.addEventListener('click', hideCartNotification);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') hideCartNotification();
      });
    }

    function formatShopifyFormErrors(data) {
      if (!data) return '';
      if (typeof data.errors === 'string') return data.errors;
      if (Array.isArray(data.errors)) return data.errors.join('. ');
      if (data.errors && typeof data.errors === 'object') {
        return Object.values(data.errors).flat().join('. ');
      }
      if (data.description) return data.description;
      if (data.message) return data.message;
      return '';
    }

    function isAlreadySubscribedError(message) {
      return /already been taken|already subscribed|already exists/i.test(message || '');
    }

    function extractShopifyFormErrorFromHtml(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const errorEl =
        doc.querySelector('#ContactFooter-error, #contact_form .errors, [data-customer-form] .errors') ||
        doc.querySelector('form[id*="customer"] .errors');
      if (errorEl) return errorEl.textContent.trim();

      if (/already been taken|invalid email|can't be blank/i.test(html)) {
        const match = html.match(/<div class="errors[^"]*">([\s\S]*?)<\/div>/i);
        if (match) return match[1].replace(/<[^>]+>/g, ' ').trim();
      }
      return '';
    }

    async function submitShopifyCustomerForm(form) {
      const action = form.getAttribute('action') || '/contact';
      const formData = new FormData(form);

      const response = await fetch(action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      const rawText = await response.text();
      let data = null;

      try {
        data = JSON.parse(rawText);
      } catch (e) {
        data = null;
      }

      if (data) {
        if (data.status === 'success' || data.ok === true) return true;
        const error = formatShopifyFormErrors(data);
        if (isAlreadySubscribedError(error)) return true;
        throw new Error(error || 'Could not subscribe. Please try again.');
      }

      if (/customer_posted=true|"status":"success"|form posted successfully/i.test(rawText)) return true;

      const htmlError = extractShopifyFormErrorFromHtml(rawText);
      if (isAlreadySubscribedError(htmlError)) return true;
      if (htmlError) throw new Error(htmlError);

      if (response.ok) return true;
      throw new Error('Something went wrong. Please try again.');
    }

    function wireShopifyCaptcha(form) {
      if (!form || form.dataset.captchaWired === 'true') return;
      if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
        window.Shopify.captcha.protect(form);
        form.dataset.captchaWired = 'true';
      }
    }

    function hasCaptchaToken(form) {
      const token = form.querySelector('[name="h-captcha-response"]');
      return token && token.value;
    }

    function submitWithCaptcha(form, onReady) {
      if (!window.Shopify || !window.Shopify.captcha || typeof window.Shopify.captcha.protect !== 'function') {
        onReady();
        return;
      }

      if (hasCaptchaToken(form)) {
        onReady();
        return;
      }

      window.Shopify.captcha.protect(form, onReady);
    }

    function initNewsletterForms() {
      const newsletterPosted = window.location.hash === '#footer-newsletter';

      if (newsletterPosted) {
        const section = document.getElementById('footer-newsletter');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      const footerForm = document.getElementById('FooterNewsletterForm');
      if (footerForm) {
        wireShopifyCaptcha(footerForm);
        footerForm.addEventListener('submit', (event) => {
          if (footerForm.dataset.captchaSubmitting === 'true') {
            footerForm.dataset.captchaSubmitting = '';
            return;
          }
          if (hasCaptchaToken(footerForm)) return;
          event.preventDefault();
          footerForm.dataset.captchaSubmitting = 'true';
          submitWithCaptcha(footerForm, () => footerForm.submit());
        });
      }
    }

    function showDiscountPopupSuccess(root) {
      const signup = root.querySelector('[data-discount-popup-signup]');
      const success = root.querySelector('[data-discount-popup-success]');
      if (signup) signup.hidden = true;
      if (success) success.hidden = false;
    }

    function initDiscountPopup() {
      const root = document.querySelector('[data-discount-popup]');
      if (!root) return;

      const storageKey = 'star-jewelry-discount-popup';
      const modal = root.querySelector('.discount-popup__modal');
      const signup = root.querySelector('[data-discount-popup-signup]');
      const success = root.querySelector('[data-discount-popup-success]');
      const errorEl = root.querySelector('[data-discount-popup-error]');

      const popupForm = root.querySelector('#DiscountPopupForm');
      const popupHasErrors = popupForm && popupForm.querySelector('.rosia-form-message--error:not([hidden])');

      if (root.dataset.subscribedSuccess === 'true' && !popupHasErrors) {
        sessionStorage.setItem(storageKey, '1');
        root.removeAttribute('hidden');
        root.classList.add('is-visible');
        if (modal) modal.classList.add('is-visible');
        showDiscountPopupSuccess(root);
      } else if (popupHasErrors) {
        root.removeAttribute('hidden');
        root.classList.add('is-visible');
        if (modal) modal.classList.add('is-visible');
      }

      const show = () => {
        if (sessionStorage.getItem(storageKey)) return;
        root.removeAttribute('hidden');
        requestAnimationFrame(() => {
          root.classList.add('is-visible');
          if (modal) modal.classList.add('is-visible');
          const popupForm = root.querySelector('#DiscountPopupForm');
          if (popupForm) wireShopifyCaptcha(popupForm);
        });
      };

      window.setTimeout(show, 2500);

      const dismiss = () => {
        root.classList.remove('is-visible');
        if (modal) modal.classList.remove('is-visible');
        window.setTimeout(() => root.setAttribute('hidden', ''), 280);
        sessionStorage.setItem(storageKey, '1');
      };

      root.querySelectorAll('[data-discount-popup-close]').forEach((btn) => {
        btn.addEventListener('click', dismiss);
      });

      const form = root.querySelector('#DiscountPopupForm');
      if (form) {
        wireShopifyCaptcha(form);

        form.addEventListener('submit', (event) => {
          if (form.dataset.captchaSubmitting === 'true') {
            form.dataset.captchaSubmitting = '';
            sessionStorage.setItem(storageKey, '1');
            return;
          }

          const submitBtn = form.querySelector('[data-discount-popup-submit]');
          if (submitBtn) submitBtn.disabled = true;

          if (hasCaptchaToken(form)) {
            sessionStorage.setItem(storageKey, '1');
            return;
          }

          event.preventDefault();
          form.dataset.captchaSubmitting = 'true';
          submitWithCaptcha(form, () => {
            sessionStorage.setItem(storageKey, '1');
            form.submit();
          });
        });
      }
    }

    async function changeCartLine(line, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Could not update cart');
      }
      window.location.reload();
    }

    function initCartPage() {
      document.querySelectorAll('[data-cart-qty-wrap]').forEach((wrap) => {
        const input = wrap.querySelector('[data-cart-qty-input]');
        const dec = wrap.querySelector('[data-cart-qty-decrease]');
        const inc = wrap.querySelector('[data-cart-qty-increase]');
        const row = wrap.closest('[data-cart-line]');
        const line = row ? Number(row.dataset.cartLine) : 0;
        if (!input || !dec || !inc || !line) return;

        dec.addEventListener('click', async () => {
          const next = Math.max(0, Number(input.value) - 1);
          try {
            await changeCartLine(line, next);
          } catch (e) {
            window.alert(e.message);
          }
        });
        inc.addEventListener('click', async () => {
          const next = Number(input.value) + 1;
          try {
            await changeCartLine(line, next);
          } catch (e) {
            window.alert(e.message);
          }
        });
      });

      document.querySelectorAll('[data-cart-remove]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const line = Number(btn.dataset.line);
          if (!line) return;
          try {
            await changeCartLine(line, 0);
          } catch (e) {
            window.alert(e.message);
          }
        });
      });
    }

    function initHomeReviewsCarousel(root) {
      const scope = root || document;
      scope.querySelectorAll('[data-rosia-home-reviews]').forEach((section) => {
        if (section.dataset.reviewsCarouselReady === 'true') return;
        section.dataset.reviewsCarouselReady = 'true';

        const track = section.querySelector('[data-reviews-track]');
        const prev = section.querySelector('[data-reviews-prev]');
        const next = section.querySelector('[data-reviews-next]');
        if (!track) return;

        const cards = () => Array.from(track.querySelectorAll('.rosia-review-card'));
        if (!cards().length) return;

        let currentIndex = 0;

        const getGap = () =>
          parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 24;

        const scrollToIndex = (index, smooth) => {
          const list = cards();
          if (!list.length) return;
          currentIndex = Math.max(0, Math.min(index, list.length - 1));
          const card = list[currentIndex];
          const targetLeft = Math.max(0, card.offsetLeft - getGap());
          track.scrollTo({
            left: targetLeft,
            behavior: smooth === false ? 'auto' : 'smooth',
          });
          updateArrows();
        };

        const syncIndexFromScroll = () => {
          const list = cards();
          if (!list.length) return;
          let closest = 0;
          let minDist = Infinity;
          list.forEach((card, index) => {
            const dist = Math.abs(card.offsetLeft - track.scrollLeft);
            if (dist < minDist) {
              minDist = dist;
              closest = index;
            }
          });
          currentIndex = closest;
          updateArrows();
        };

        const updateArrows = () => {
          const total = cards().length;
          if (prev) {
            const atStart = currentIndex <= 0;
            prev.disabled = atStart;
            prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
          }
          if (next) {
            const atEnd = currentIndex >= total - 1;
            next.disabled = atEnd;
            next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
          }
        };

        if (prev) {
          prev.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            scrollToIndex(currentIndex - 1);
          });
        }

        if (next) {
          next.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            scrollToIndex(currentIndex + 1);
          });
        }

        let scrollTimer;
        track.addEventListener(
          'scroll',
          () => {
            window.clearTimeout(scrollTimer);
            scrollTimer = window.setTimeout(syncIndexFromScroll, 80);
          },
          { passive: true }
        );

        window.addEventListener('resize', () => scrollToIndex(currentIndex, false));

        let dragActive = false;
        let dragStartX = 0;
        let dragStartScroll = 0;
        let dragMoved = false;

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          dragActive = true;
          dragMoved = false;
          dragStartX = event.clientX;
          dragStartScroll = track.scrollLeft;
          track.setPointerCapture(event.pointerId);
          track.classList.add('is-dragging');
        });

        track.addEventListener('pointermove', (event) => {
          if (!dragActive) return;
          const delta = event.clientX - dragStartX;
          if (Math.abs(delta) > 4) dragMoved = true;
          track.scrollLeft = dragStartScroll - delta;
        });

        const endDrag = (event) => {
          if (!dragActive) return;
          dragActive = false;
          track.classList.remove('is-dragging');
          if (track.hasPointerCapture(event.pointerId)) {
            track.releasePointerCapture(event.pointerId);
          }
          if (dragMoved) {
            syncIndexFromScroll();
          }
        };

        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);

        track.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              scrollToIndex(currentIndex - 1);
            }
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              scrollToIndex(currentIndex + 1);
            }
          },
          { passive: false }
        );

        scrollToIndex(0, false);
      });
    }

    window.StarJewelryCart = {
      add: addToCartAjax,
      refresh: refreshCartCount,
    };

    window.initHomeReviewsCarousel = initHomeReviewsCarousel;

    document.addEventListener('DOMContentLoaded', () => {
      initLocalizationForms();
      initMobileMenu();
      initHistoryBack();
      initAccordions();
      initReadMore();
      initQuantity(document);
      initProductPage();
      initProductRecommendations();
      initRosiaPdp();
      initCartNotification();
      initDiscountPopup();
      initNewsletterForms();
      initCartPage();
      initHomeReviewsCarousel();
    });

    document.addEventListener('shopify:section:load', (event) => {
      initHomeReviewsCarousel(event.target);
    });
  })();
  